import { useCallback } from 'react';

import { useAuthStore } from 'src/auth/auth.store';
import { useBoolean } from 'src/hooks/use-boolean';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

import { useSearch } from './app-header-search';

export const useAppHeader = () => {
  const { clearTokens } = useAuthStore((state) => state);
  const { setSearchTerm, safeOptions } = useSearch();
  const { replace } = useRouter();
  const modal = useBoolean(false);

  const onClickLogout = () => modal.onTrue();

  const onClickConfirmLogout = () => {
    clearTokens();
    replace(paths.auth.login);
    modal.onFalse();
  };

  const handleSelectOption = useCallback(
    (option: { label: string; value: string; path?: string; icon: React.ReactNode } | null) => {
      if (option?.path) {
        replace(option.path);
        setSearchTerm('');
      }
    },
    [replace, setSearchTerm]
  );

  return {
    modal,
    onClickLogout,
    onClickConfirmLogout,
    setSearchTerm,
    searchOptions: safeOptions,
    handleSelectOption,
  };
};
